import VueRamUtils from "vue-ram-utils";

const axios_token = VueRamUtils.axios_token;
export default {
    login: (context, user_data) => {
        context.commit("set_wait_auth", true);
        context.commit("set_token", null);
        console.log("login request", user_data);
        return axios_token
            .post("login/", {...user_data})
            .then((response) => response.data)
            .then(function (data) {
                console.log("login response", data);
                context.commit("set_token", data.token);
                return context.dispatch("init_auth");
            })
            .catch(function (error) {
                console.log("login error", error);
                context.commit("set_token", null);
                context.commit("set_wait_auth", false);
                throw error;
            });
    },
    logout: (context) => {
        return new Promise(function (resolve) {
            context.commit("set_wait_auth", false);
            console.log("logout request");
            context.commit("set_token", null);
            resolve();
        });
    },
    init_auth: (context) => {
        if (!context.state.token) return;
        context.commit("set_wait_auth", true);
        return axios_token
            .post("userinfo/")
            .then((response) => response.data)
            .then(function (data) {
                context.commit("set_userdata", data);
                console.log("init_auth Valid User", data);
                context
                    .dispatch("menu/load_menu", null, {root: true})
                    .then(function () {
                        context.commit("set_wait_auth", false);
                    });
            })
            .catch(function (error) {
                console.log("init_auth Invalid User", error);
                context.commit("set_wait_auth", false);
                context.commit("set_token", null);
                throw error;
            });
    },
    refresh_userinfo: (context) => {
        return axios_token
            .post("userinfo/")
            .then((response) => response.data)
            .then(function (data) {
                context.commit("set_userdata", data);
                // console.log("refresh_userinfo", data)
            });
    },
};
